import { logger } from "./logger";

const parseXmlText = (xmlText) => new DOMParser().parseFromString(xmlText, "text/xml");

const parseNumberList = (value) =>
  String(value || "")
    .trim()
    .split(/\s+/)
    .map(Number)
    .filter((n) => Number.isFinite(n));

const isZeroVec3 = (value) => {
  if (!value) return true;
  const nums = parseNumberList(value);
  return nums.length >= 3 && nums.slice(0, 3).every((n) => Math.abs(n) < 1e-12);
};

const isIdentityQuat = (value) => {
  if (!value) return true;
  const nums = parseNumberList(value);
  return (
    nums.length >= 4 &&
    Math.abs(nums[0] - 1) < 1e-12 &&
    nums.slice(1, 4).every((n) => Math.abs(n) < 1e-12)
  );
};

const hasIdentityRootFrame = (body) =>
  isZeroVec3(body.getAttribute("pos")) &&
  isIdentityQuat(body.getAttribute("quat")) &&
  !body.hasAttribute("euler") &&
  !body.hasAttribute("axisangle") &&
  !body.hasAttribute("xyaxes") &&
  !body.hasAttribute("zaxis");

const getDirectChildrenByTag = (parent, tagName) =>
  Array.from(parent.childNodes).filter(
    (node) => node.nodeType === Node.ELEMENT_NODE && node.tagName?.toLowerCase() === tagName
  );

export const applyMjcfCatalogTransforms = (xmlText, asset = {}) => {
  const rootBodyName = asset.groupWorldbodyBodiesUnderRoot;
  if (!rootBodyName) return xmlText;

  const xmlDoc = parseXmlText(xmlText);
  const worldbody = xmlDoc.querySelector("mujoco > worldbody");
  if (!worldbody) return xmlText;

  const rootBody = getDirectChildrenByTag(worldbody, "body").find(
    (body) => body.getAttribute("name") === rootBodyName
  );
  if (!rootBody) {
    logger.warn(
      `[mjcfCatalogTransforms] Root body "${rootBodyName}" not found; skipping grouping transform.`
    );
    return xmlText;
  }
  if (!hasIdentityRootFrame(rootBody)) {
    logger.warn(
      `[mjcfCatalogTransforms] Root body "${rootBodyName}" is not in the identity world frame; skipping grouping transform.`
    );
    return xmlText;
  }

  const bodiesToMove = getDirectChildrenByTag(worldbody, "body").filter(
    (body) => body !== rootBody
  );
  const sitesToMove =
    asset.groupWorldbodySitesUnderRoot === false ? [] : getDirectChildrenByTag(worldbody, "site");

  [...sitesToMove, ...bodiesToMove].forEach((node) => {
    rootBody.appendChild(node);
  });

  return new XMLSerializer().serializeToString(xmlDoc);
};
